let k;
const b = new Uint8Array(16);
function D() {
  if (!k && (k = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !k))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return k(b);
}
const i = [];
for (let n = 0; n < 256; ++n)
  i.push((n + 256).toString(16).slice(1));
function U(n, e = 0) {
  return (i[n[e + 0]] + i[n[e + 1]] + i[n[e + 2]] + i[n[e + 3]] + "-" + i[n[e + 4]] + i[n[e + 5]] + "-" + i[n[e + 6]] + i[n[e + 7]] + "-" + i[n[e + 8]] + i[n[e + 9]] + "-" + i[n[e + 10]] + i[n[e + 11]] + i[n[e + 12]] + i[n[e + 13]] + i[n[e + 14]] + i[n[e + 15]]).toLowerCase();
}
const w = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), h = {
  randomUUID: w
};
function P(n, e, t) {
  if (h.randomUUID && !e && !n)
    return h.randomUUID();
  n = n || {};
  const c = n.random || (n.rng || D)();
  if (c[6] = c[6] & 15 | 64, c[8] = c[8] & 63 | 128, e) {
    t = t || 0;
    for (let r = 0; r < 16; ++r)
      e[t + r] = c[r];
    return e;
  }
  return U(c);
}
function R(n = 5e3, e = 5e3) {
  let t = null, c = null, r = null, d = null;
  const f = (o) => {
    r = o;
  }, y = (o) => {
    d = o;
  }, m = () => {
    r.readyState === 1 && (t = T(), r.send(JSON.stringify(t)), c = setTimeout(() => {
      d(), u();
    }, e));
  }, S = function(o) {
    o.type === "Pong" && t && o.ack === t.id && (clearTimeout(c), setTimeout(() => {
      m();
    }, n));
  }, p = function(o) {
    o.type === "Ping" && (t = {
      id: P(),
      ack: o.id,
      type: "Pong"
    }, r.send(JSON.stringify(t)));
  }, u = function() {
    t = null, d = null, r = null, clearTimeout(c);
  };
  return {
    sendPing: m,
    setCloseTimeoutHandler: y,
    handlePong: S,
    handlePing: p,
    setWebsocket: f
  };
}
function T() {
  return {
    type: "Ping",
    id: P(),
    timestamp: Date.now()
  };
}
const I = (n) => {
  const e = {}, t = {};
  let c = !1;
  const r = () => {
    for (let o in e)
      if (e[o].readyState === 0 || e[o].readyState === 1)
        return {
          id: o,
          connection: e[o]
        };
    return null;
  };
  return {
    setParams: (o, l) => {
      t[o] = l;
    },
    disconnect: () => {
      c = !0;
    },
    isDisconnected: () => c,
    create: () => r() !== null ? null : (c = !1, new WebSocket(O(
      n,
      t
    ))),
    set: (o, l) => {
      e[l] = o;
    },
    findActiveSocket: () => {
      for (let o in e)
        if (e[o].readyState === 1)
          return e[o];
      return null;
    },
    remove: (o) => {
      e[o].onerror = () => {
      }, e[o].onclose = () => {
      }, e[o].close(), delete e[o];
    },
    findConnectingOrActiveSocket: r
  };
};
function O(n, e) {
  return new URL("?" + new URLSearchParams(e).toString(), n);
}
const s = {
  oninitialise: "oninitialise",
  beforeConnect: "beforeConnect",
  ondisconnect: "ondisconnect",
  onReconnect: "onReconnect",
  onerror: "onerror",
  onopen: "onopen",
  onmessage: "onmessage",
  onclose: "onclose",
  onSendMessageSuccessful: "onSendMessageSuccessful",
  errorReport: "errorReport"
};
function C(n) {
  const e = {};
  return Object.values(n).forEach((t) => e[t] = () => {
  }), e;
}
const x = () => {
  const n = C(s);
  return {
    set: (e, t) => {
      if (typeof t != "function")
        throw new Error("Not a valid function was provided to the hook");
      n[e] = t;
    },
    call: (e, t) => {
      if (typeof n[e] != "function")
        throw new Error(`hook: ${e} is not a function`);
      return n[e](t);
    }
  };
};
function A() {
  return s;
}
function H(n = Object) {
  let e = null, t = x(), c = I(n.websocketUrl), r = R(
    n.pingInterval,
    n.pongTimeout
  );
  const d = () => {
    t.call(s.oninitialise);
  }, f = (u, o) => {
    c.setParams(u, o);
  }, y = (u) => new Promise((o, l) => {
    const g = c.findActiveSocket();
    g === null && l();
    try {
      g.send(JSON.stringify(u)), t.call(s.onSendMessageSuccessful), o();
    } catch {
      l();
    }
  }), m = function() {
    c.isDisconnected() || setTimeout(() => {
      c.isDisconnected() || c.findConnectingOrActiveSocket() !== null || (t.call(s.onReconnect), p({
        reconnect: !0
      }), e += n.reconnectDelayIncreaseBy);
    }, e);
  }, S = () => {
    c.disconnect();
    const u = c.findConnectingOrActiveSocket();
    u !== null && (c.remove(u.id), t.call(s.ondisconnect));
  }, p = function(u = { reconnect: !0 }) {
    t.call(s.beforeConnect);
    const o = P(), l = c.create();
    if (l === null)
      return;
    r.setWebsocket(l), r.setCloseTimeoutHandler(() => {
      t.call(s.errorReport, {
        reason: "Did not receive pong from server and timeouted."
      }), c.remove(o), t.call(s.onclose), m();
    });
    let g = null;
    l.onmessage = (a) => {
      const v = JSON.parse(a.data);
      r.handlePong(v), r.handlePing(v), t.call(s.onmessage, v);
    }, l.onopen = () => {
      e = n.reconnectDelayInitialValue, g && clearTimeout(g), r.sendPing(), t.call(s.onopen);
    }, l.onclose = (a) => {
      t.call(s.errorReport, a), t.call(s.onclose, a);
    }, l.onerror = (a) => {
      t.call(s.errorReport, a), t.call(s.onerror, a);
    }, u.reconnect && (g = setTimeout(() => {
      c.remove(o), m();
    }, n.reconnectInterval)), c.set(l, o);
  };
  return {
    initialise: d,
    connect: p,
    disconnect: S,
    hooks: t,
    setSocketParams: f,
    send: y
  };
}
export {
  A as WebsocketHooks,
  H as WebsocketPlugin
};
